import React, { Suspense, Fragment, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SidebarLayout from "./Layout/SidebarLayout";
import Authenticated from "./Guard/Authenticated";
import Guest from "./Guard/Guest";
import BaseLayout from "./Layout/BaseLayout";
import LoadScreen from "./Component/loaderScreen";
import BaseLayouts from "./Layout/Website/BaseLayouts";
export function RenderRout() {
  return (
    <>
      <Router>
        <Suspense fallback={<LoadScreen />}>
          <Routes>
            {routes?.map((route, i) => {
              const Guard = route?.guard || Fragment;
              const Auth = route?.auth || Fragment;
              const Layout = route?.layout || Fragment;
              const Component = route?.element;
              return (
                <Route
                  key={i}
                  path={route.path}
                  exact={route.exact}
                  element={
                    <Guard>
                      <Auth>
                        <Layout>
                          <Component />
                        </Layout>
                      </Auth>
                    </Guard>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

const routes = [
  // Auth Pages
  {
    layout: BaseLayouts,
    exact: true,
    path: "/:token?/:type?",
    element: lazy(() => import("./Component/Pages/Website/Home/Index")),
  },
   {
    layout: BaseLayouts,
    exact: true,
    path: "/cancel-subscription/:id",
    element: lazy(() => import("./Component/Pages/Stripe/CancelSubscription")),
  },
  {
    layout: BaseLayouts,
    exact: true,
    path: "/contact",
    element: lazy(() => import("./Component/Pages/Website/Contact/Index")),
  },
  {
    layout: BaseLayouts,
    exact: true,
    path: "/license",
    element: lazy(() => import("./Component/Pages/Website/Contact/License")),
  },

   {
    layout: BaseLayouts,
    exact: true,
    path: "/privacy-policy/:type?",
    element: lazy(() => import("./Component/Pages/Website/Contact/Privacypolicy")),
  },

  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/user/login",
    element: lazy(() => import("./Component/Pages/Website/Auth/Login")),
  },

  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/user/register",
    element: lazy(() => import("./Component/Pages/Website/Auth/Register")),
  },



  {
    guard: Guest,
    layout: BaseLayout,
    exact: true,
    path: "/admin/login",
    element: lazy(() => import("./Component/Pages/Auth/Login")),
  },

  
  //Dashboard Pages
  {
    guard: Authenticated,
    layout: SidebarLayout,
    exact: true,
    path: "/dashboard",
    element: lazy(() => import("./Component/Pages/Dasboards/Index")),
  },

//Languages
{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/languages",
  element: lazy(() => import("./Component/Pages/Languages/Index")),
},
//users
{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/users",
  element: lazy(() => import("./Component/Pages/Users/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/contacts",
  element: lazy(() => import("./Component/Pages/Contact/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/category",
  element: lazy(() => import("./Component/Pages/Category/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/sub-category",
  element: lazy(() => import("./Component/Pages/SubCategory/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/sub-category/detail/:id/:key",
  element: lazy(() => import("./Component/Pages/SubCategory/SubcategoryContent")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/sub-category/content/:id/:key/:sub?",
  element: lazy(() => import("./Component/Pages/SubCategory/AddEditContent")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/sub-category/content-edit/:id/:key/:catid",
  element: lazy(() => import("./Component/Pages/SubCategory/EditContent")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/sub-category/content-list/:id/:key/:catid",
  element: lazy(() => import("./Component/Pages/SubCategory/Contentlist")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/sub-category/content-list-add/:id/:key/:catid/:subcatid?",
  element: lazy(() => import("./Component/Pages/SubCategory/Contentlistadd")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/prayer",
  element: lazy(() => import("./Component/Pages/Prayer/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/assistant",
  element: lazy(() => import("./Component/Pages/Assistant/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/assistant/:id",
  element: lazy(() => import("./Component/Pages/Assistant/ChildList")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/media",
  element: lazy(() => import("./Component/Pages/Media/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/keyborad",
  element: lazy(() => import("./Component/Pages/Prayerkeyword/Index")),
},


{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/report",
  element: lazy(() => import("./Component/Pages/PrayerReport/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/admincontact",
  element: lazy(() => import("./Component/Pages/AdminContact/Index")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/adminbible",
  element: lazy(() => import("./Component/Pages/BiblePrayer/BiblePrayer")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/adminbible/:id",
  element: lazy(() => import("./Component/Pages/BiblePrayer/VieBiblePrayer")),
},

{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/adminbible/sub/:id",
  element: lazy(() => import("./Component/Pages/BiblePrayer/VieBiblePrayersub")),
},
{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/adminbible/sub/add/:id/:subid?",
  element: lazy(() => import("./Component/Pages/BiblePrayer/AddEditsub")),
},
{
  guard: Authenticated,
  layout: SidebarLayout,
  exact: true,
  path: "/media/:id",
  element: lazy(() => import("./Component/Pages/Media/Subcategorymedia")),
},

{
  layout: BaseLayout,
  exact: true,
  path: '/payment_success',
  element: lazy(() => import('./Component/Pages/Stripe/PaymentSucess'))

},
{
  layout: BaseLayout,
  exact: true,
  path: '/payment_failed',
  element: lazy(() => import('./Component/Pages/Stripe/PaymentFailed'))

},

  ///404 Page

  {
    layout: BaseLayout,
    exact: true,
    path: "*",
    element: lazy(() => import("./Component/PageNotFound")),
  },
];
